<template>
  <div>
    <loader :status="is_saving" />
    <b-row class="m-0 mb-2 rounded border" v-if="params.form.id!=-1">
      <b-col sm="12" md="3" class="p-2">
        <div class="w-100 border p-2 bg-dark rounded">
          <img
            v-if="params.form.image=='' || params.form.image==null"
            class="w-100 cursor-pointer"
            :src="assets_path.DEFAULT_URL+'/img/image-not-found.jpg'"
            @click="upload_modal=true"
          />
          <img
            v-else
            class="w-100 cursor-pointer"
            :src="assets_path.MANPOWERS + params.form.image"
            @click="upload_modal=true"
          />
        </div>
      </b-col>
      <b-col class="pl-0 pr-2">
          <b-row class="m-0 border p-2 rounded my-2 loan-app-container">
            <b-col class="p-0">

                <!--<b-alert v-if="params.form.is_payroll==1" variant="success" show class="mt-2">Employee is <strong>INCLUDED</strong> in daily attendance sheet.</b-alert>-->
                <!--<b-alert v-else variant="danger" show class="mt-2">Employee is <strong>EXCLUDED</strong> in daily attendance sheet.</b-alert>-->
                <b-row class="m-0">
                    <b-col cols="1" class="text-center p-2 bg-dark text-white d-flex align-items-center justify-content-center">
                        <!-- <font-awesome-icon icon="user" class="h2 mb-0" /> -->
                        <font-awesome-icon icon="qrcode" class="h2 mb-0  cursor-pointer" title="View Employee QR" @click="generateQr()"/>
                    </b-col>
                    <b-col class="p-3 bg-light d-flex align-items-center">
                        <div class="w-100">
                            <h4 class="mb-0 text-uppercase"><strong>{{params.form.full_name}}</strong> <span class="float-right"><b-badge variant="info">ID NUMBER : {{params.form.id_number}}</b-badge></span></h4>
                            <small class="text-muted text-uppercase font-weight-bold">{{(params.form.job_description == null) ? 'No Job Title Yet' : params.form.job_description.manpower_job_description.description}}</small> |
                            <b-badge :variant="(params.form.employment_status == null) ? 'danger' : 'primary'">{{(params.form.employment_status == null) ? 'No Employment Status Yet' : params.form.employment_status.employment_status.description}}</b-badge>
                        </div>
                    </b-col>
                </b-row>
                <!--<b-button @click="payroll(1)" block variant="facebook" size="sm" class="mt-3" v-if="params.form.is_payroll==0">-->
                    <!--<font-awesome-icon icon="check-circle" /> INCLUDE FROM DAILY PAYROLL-->
                <!--</b-button>-->
                <!--<b-button @click="payroll(0)" block variant="facebook" size="sm" class="mt-3" v-else>-->
                    <!--<font-awesome-icon icon="times-circle" /> EXCLUDE FROM DAILY PAYROLL-->
                <!--</b-button>-->
            </b-col>
          </b-row>
      </b-col>
    </b-row>
    <b-form @submit="save">
    <b-tabs content-class="mt-3">
      <b-tab title="Basic Information" active>
        <basic-info :params="params" @save="get()"/>
      </b-tab>
      <b-tab title="Qualifications">
        <qualifications-info :params="params"  @save="get()"/>
      </b-tab>
        <b-tab title="Dependents">
            <dependents-info :params="params" @save="get()"/>
        </b-tab>
        <b-tab title="Social Media">
            <social-media-info :params="params" @save="get()"/>
        </b-tab>
        <b-tab title="Preferences">
            <preferences :params="params" @save="get()"/>
        </b-tab>
        <b-tab title="Job Details">
            <job-details :params="params" @save="get()"/>
        </b-tab>
        <b-tab title="Awards">
            <awards :params="params" @save="get()"/>
        </b-tab>
        <b-tab title="Attendance Sheet">
            <attendance-sheet :params="params" @save="get()"/>
        </b-tab>
        <b-tab title="Cash Advances">
            <cash-advance :params="params" @save="get()"/>
        </b-tab>
        <b-tab title="Contributions" lazy>
            <contributions :params="params"/>
        </b-tab>
    </b-tabs>
    <div class="text-right mt-3">
      <b-btn-group size="sm">
      <!-- <router-link to="/manpowers/all"> -->
          <b-button v-if="params.form.id!=-1 && manpower_id ==-1" variant="dark" size="sm"  @click="$router.push('/members/all')">
          <font-awesome-icon icon="chevron-left" /> Back</b-button>
      <!-- </router-link> -->
      <b-button type="submit" variant="info"><font-awesome-icon icon="save" /> Save</b-button>
      </b-btn-group>
    </div>
    </b-form>
    <b-modal
      v-model="upload_modal"
      centered
      size="md"
      body-class="p-0"
      :hide-footer="true"
      :hide-header="true"
    >
      <div class="card mb-0">
        <div
          class="card-header bg-facebook text-white d-flex align-items-center justify-content-between"
        >
          <h6 class="mb-0">
            <!--<font-awesome-icon icon="upload" />-->
            Upload a Picture
          </h6>
        </div>
        <div class="card-body position-relative">
          <loader :status="is_saving" />
          <div class="custom-file mb-3">
            <input
              type="file"
              class="custom-file-input"
              accept="image/*"
              @change="onChange"
              required
            />
            <label class="custom-file-label" for="validatedCustomFile">Choose file...</label>
          </div>
          <div id="preview" class="mb-3">
            <img v-if="item.imageUrl" :src="item.imageUrl" class="w-100" />
          </div>
          <b-progress
            v-if="hide_submit_btn"
            :variant="loading_color"
            :value="percentage"
            :max="max_upload_percentage"
            show-progress
            animated
            height="1.5rem"
          >
            <b-progress-bar :value="percentage" v-if="percentage>0">
              <!-- <strong v-if="file.error_title!=''">{{ file.name }} - ERROR!</strong> -->
              <strong>{{ percentage }}%</strong>
            </b-progress-bar>
          </b-progress>
          <b-button v-else @click="upload()" block variant="success" :disabled="item.image==null" size="sm">
            <font-awesome-icon icon="check-circle" /> UPLOAD
          </b-button>
        </div>
      </div>
    </b-modal>
    

    <b-modal v-model="qr_generator_modal" centered size="md" body-class="p-0" :hide-footer="true" :hide-header="true">
      <qr-code-generator :code="params.form.id_number" />
    </b-modal>


  </div>
</template>
<script>
    import SwalMixin from '@/views/mixins/Swal.js'
    import Loader from '@/views/helpers/LoaderComponent.vue';
    import BasicInfo from './BasicInfo.vue';
    import DependentsInfo from './DependentsInfo.vue';
    import SocialMediaInfo from './SocialMediaInfo.vue';
    import Preferences from './Preferences.vue';
    import QualificationsInfo from './QualificationsInfo.vue';
    import JobDetails from './JobDetails.vue';
    import Awards from './Awards.vue';
    import AttendanceSheet from './AttendanceSheet.vue';
    import CashAdvance from './CashAdvance.vue';
    import Contributions from './Contributions.vue';
    import { assets_path } from "@/config";
    import QrCodeGenerator from '@/views/helpers/QrCodeGenerator.vue';
    export default {
      mixins:[SwalMixin],
      components: {Loader,BasicInfo,DependentsInfo,QualificationsInfo,SocialMediaInfo,JobDetails,Awards,Preferences,AttendanceSheet,CashAdvance,Contributions,QrCodeGenerator},
      props:{
          manpower_id: {
              type: Number,
              default: -1
          },
      },
      data() {
        return {
          params:{
            form: {
                id:-1,
                employee_id:'',
                id_number:'',
                first_name: '',
                middle_name: '',
                last_name: '',
                suffix: '',
                nickname:'',
                dob: '',
                job_description_id:'',
                blood_type_id:'',
                shirt_size_id:'',
                marital_status_id:'',
                gender_id:'',
                province_id: '',
                city_id: '',
                barangay: '',
                street_address: '',
                contact_number: '',
                work_email: '',
                other_email: '',
                sss_number:'',
                philhealth_number:'',
                pagibig_number:'',
                date_hired: '',
                probation_end_date: '',
                regularization_date:'',
                image:'',
                manpower_emergency_contacts:[],
                manpower_social_media:[],
                manpower_work_experiences:[],
                manpower_educations:[],
                manpower_dependents:[],
                is_payroll:1,
                shift_type_id:null,
                salary_type_id:null,
                sss:'',
                hdmf:'',
                phic:'',

            },
            fields:{
              genders:[],
                marital_statuses:[],
                provinces:[],
                blood_types:[],
                shirt_sizes:[],
                preference_categories:[],
                shift_types:[],
                salary_types:[]
            },
              cash_advances:[],
              payments:[]
          },
          is_saving:false,
          item: {
            image: null,
            imageUrl: null,
            imageName: "",
          },
          assets_path: {},
          upload_modal: false,
          percentage: 0,
          loading_color: "facebook",
          max_upload_percentage: 100,
          hide_submit_btn: false,
          cameraModal: false,
          qr_generator_modal:false
        }
      },
	  computed:{
		completeAddress(){
			if(this.params.form.city === null)
				return ''
			//return this.params.form.street_address+", "+this.params.form.barangay+", "+this.params.form.city.name +", "+this.params.form.province.name;
		}
	  },
      created(){
        this.assets_path = assets_path;
        this.get();

      },
      methods: {
        get(){
          this.is_saving=true;
          let manpower_id = (this.manpower_id !=-1) ? this.manpower_id : this.$route.params.id;
          this.axios.get('maintenance/manpowers/get',{params:{id:manpower_id}}).then(response => {
              let data = response.data;
              data.form.manpower_leave_benefits.forEach((value, index) => {
                  let row = data.leave_credits.find(element => element.leave_benefit_id==value.leave_benefit_id);
                  value.leave_balance_credits = row.balance;
              });
              this.params=data;
              this.is_saving=false;
          }).catch(error => console.log(error));
        },
          save(){
              event.preventDefault()
              this.swalConfirmSubmit((data)=>{
                  if (data.value) {
                      this.is_saving=true;
                      let form =  {
                          id:this.params.form.id,
                          employee_id:this.params.form.employee_id,
                          id_number:this.params.form.id_number,
                          first_name:this.params.form.first_name,
                          middle_name:this.params.form.middle_name,
                          last_name:this.params.form.last_name,
                          suffix:this.params.form.suffix,
                          nickname:this.params.form.nickname,
                          dob: this.params.form.dob,
                          blood_type_id:this.params.form.blood_type_id,
                          shirt_size_id:this.params.form.shirt_size_id,
                          marital_status_id:this.params.form.marital_status_id,
                          gender_id:this.params.form.gender_id,
                          province_id: this.params.form.province_id,
                          city_id: this.params.form.city_id,
                          barangay: this.params.form.barangay,
                          street_address:this.params.form.street_address,
                          contact_number: this.params.form.contact_number,
                          work_email: this.params.form.work_email,
                          other_email: this.params.form.other_email,
                          sss_number: this.params.form.sss_number,
                          philhealth_number: this.params.form.philhealth_number,
                          pagibig_number: this.params.form.pagibig_number,
                          preferences:this.params.fields.preference_categories,

                          shift_type_id: this.params.form.shift_type_id,
                          salary_type_id: this.params.form.salary_type_id,
                          sss: this.params.form.sss,
                          hdmf: this.params.form.hdmf,
                          phic: this.params.form.phic,
                      }
                      //this.params.form.province_id = this.params.form.province.id;
                      this.axios.post('maintenance/manpowers/update',form).then(response => {
                          this.swalTransactionCompleted();
                          this.is_saving=false;
                          this.get();
                      }).catch(error => {
                          this.swal_transaction_error_data.text = error.response.data;
                          this.swalRequestError();
                          this.is_saving=false;
                      });
                  }
              });
          },
          payroll(status){
              event.preventDefault();
              let description = (status == 1) ? 'INCLUDE' : 'EXCLUDE';
              this.swal_confirm_submit_data.title = "Do you want to "+description+" this employee from daily payroll?";
              this.swalConfirmSubmit((data)=>{
                  if (data.value) {
                      this.is_saving=true;
                      let form =  {
                          id:this.params.form.id,
                          is_payroll:status
                      }
                      //this.params.form.province_id = this.params.form.province.id;
                      this.axios.post('maintenance/manpowers/update',form).then(response => {
                          this.swalTransactionCompleted();
                          this.is_saving=false;
                          this.get();
                      }).catch(error => {
                          this.swal_transaction_error_data.text = error.response.data;
                          this.swalRequestError();
                          this.is_saving=false;
                      });
                  }
              });
          },
        dataURItoBlob(dataURI) {
          var byteString;
          if (dataURI.split(",")[0].indexOf("base64") >= 0)
            byteString = atob(dataURI.split(",")[1]);
          else byteString = unescape(dataURI.split(",")[1]);

          var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
          var ia = new Uint8Array(byteString.length);
          for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }

          return new Blob([ia], { type: mimeString });
        },
        onChange(e) {
          const file = e.target.files[0];
          this.item.image = file;
          this.item.imageUrl = URL.createObjectURL(file);
        },
        upload() {
          let formData = new FormData();
          let file = this.item.image;
          if (this.item.imageName === "") {
            formData.append("file", file);
          } else {
            formData.append("file", file, this.item.imageName);
          }
          formData.append("manpower_id", this.params.form.id);
          this.hide_submit_btn = true;
          this.axios
            .post("maintenance/manpowers/upload-image", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
              onUploadProgress: (progressEvent) => {
                this.percentage = parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                );
              },
            })
            .then((response) => {
              this.loading_color = "success";
              this.swalTransactionCompleted();
              this.upload_modal = false;
              console.log(response.data);
              this.params.form.image = response.data;
            })
            .catch((error) => {});
        },
        generateQr(){
          console.log(this.params.form.employee_id)
          if(this.params.form.id_number==''){
            this.swal_transaction_error_data.text = 'Employee have no ID Number yet.';
            this.swalRequestError();
            return;
          }
          this.qr_generator_modal=true;
        }
      }
    }
</script>
<style scoped>
.loan-app-container{
  height: calc(100% - 1rem);
}
</style>